(function () {
      "use strict";

      var STORAGE_KEY = "roundRobinGeneratorState.v1";
      var MAX_SHARE_URL_LENGTH = 1800;
      var MAX_SHARE_PAYLOAD_LENGTH = 2400;
      var MAX_NAME_LENGTH = 80;
      var MAX_SCORE = 999999;
      var profiles = {
        generic: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Location",
          venuePlural: "Locations",
          scoreA: "Score",
          scoreB: "Score",
          allowDraws: true,
          scoringBadge: "W-L-D",
          defaultCount: 16,
          defaultVenues: 2
        },
        pickleball: {
          participantSingular: "Player",
          participantPlural: "Players",
          venueSingular: "Court",
          venuePlural: "Courts",
          scoreA: "Pts",
          scoreB: "Pts",
          allowDraws: false,
          scoringBadge: "Points",
          defaultCount: 8,
          defaultVenues: 2
        },
        tennis: {
          participantSingular: "Player",
          participantPlural: "Players",
          venueSingular: "Court",
          venuePlural: "Courts",
          scoreA: "Sets",
          scoreB: "Sets",
          allowDraws: false,
          scoringBadge: "Sets",
          defaultCount: 8,
          defaultVenues: 2
        },
        chess: {
          participantSingular: "Player",
          participantPlural: "Players",
          venueSingular: "Board",
          venuePlural: "Boards",
          scoreA: "Pts",
          scoreB: "Pts",
          allowDraws: true,
          scoringBadge: "W-L-D",
          defaultCount: 8,
          defaultVenues: 4
        },
        soccer: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Field",
          venuePlural: "Fields",
          scoreA: "Goals",
          scoreB: "Goals",
          allowDraws: true,
          scoringBadge: "W-L-D",
          defaultCount: 8,
          defaultVenues: 2
        },
        basketball: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Court",
          venuePlural: "Courts",
          scoreA: "Pts",
          scoreB: "Pts",
          allowDraws: false,
          scoringBadge: "W-L",
          defaultCount: 8,
          defaultVenues: 2
        },
        volleyball: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Court",
          venuePlural: "Courts",
          scoreA: "Pts",
          scoreB: "Pts",
          allowDraws: false,
          scoringBadge: "W-L",
          defaultCount: 8,
          defaultVenues: 2
        },
        lacrosse: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Field",
          venuePlural: "Fields",
          scoreA: "Goals",
          scoreB: "Goals",
          allowDraws: true,
          scoringBadge: "W-L-D",
          defaultCount: 8,
          defaultVenues: 2
        },
        baseball: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Field",
          venuePlural: "Fields",
          scoreA: "Runs",
          scoreB: "Runs",
          allowDraws: false,
          scoringBadge: "W-L",
          defaultCount: 8,
          defaultVenues: 2
        },
        "flag-football": {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Field",
          venuePlural: "Fields",
          scoreA: "Pts",
          scoreB: "Pts",
          allowDraws: false,
          scoringBadge: "W-L",
          defaultCount: 8,
          defaultVenues: 2
        },
        hockey: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Rink",
          venuePlural: "Rinks",
          scoreA: "Goals",
          scoreB: "Goals",
          allowDraws: true,
          scoringBadge: "W-L-D",
          defaultCount: 8,
          defaultVenues: 2
        },
        esports: {
          participantSingular: "Team",
          participantPlural: "Teams",
          venueSingular: "Station",
          venuePlural: "Stations",
          scoreA: "Score",
          scoreB: "Score",
          allowDraws: false,
          scoringBadge: "W-L",
          defaultCount: 8,
          defaultVenues: 4
        }
      };

      var NAME_PREVIEW_LIMIT = 5;
      var root = document.getElementById("round-robin-app");
      if (!root || root.dataset.roundRobinInitialized === "true") return;
      root.dataset.roundRobinInitialized = "true";
      var els = {
        autosaveStatus: document.getElementById("autosaveStatus"),
        sportSelector: document.getElementById("sportSelector"),
        presetSearchInput: document.getElementById("presetSearchInput"),
        selectedSportLabel: document.getElementById("selectedSportLabel"),
        sportButtons: Array.prototype.slice.call(root.querySelectorAll("[data-sport]")),
        participantCountLabel: document.getElementById("participantCountLabel"),
        countBig: document.getElementById("countBig"),
        countSmall: document.getElementById("countSmall"),
        countDownBtn: document.getElementById("countDownBtn"),
        countUpBtn: document.getElementById("countUpBtn"),
        bulkPanel: document.getElementById("bulkPanel"),
        bulkNamesInput: document.getElementById("bulkNamesInput"),
        applyBulkBtn: document.getElementById("applyBulkBtn"),
        venueInput: document.getElementById("venueInput"),
        venueLabel: document.getElementById("venueLabel"),
        venueNamesLabel: document.getElementById("venueNamesLabel"),
        advancedHelp: document.getElementById("advancedHelp"),
        startDateInput: document.getElementById("startDateInput"),
        dayButtons: Array.prototype.slice.call(root.querySelectorAll("[data-day]")),
        timeSlotsInput: document.getElementById("timeSlotsInput"),
        venueNamesInput: document.getElementById("venueNamesInput"),
        singleBtn: document.getElementById("singleBtn"),
        doubleBtn: document.getElementById("doubleBtn"),
        singleMath: document.getElementById("singleMath"),
        doubleMath: document.getElementById("doubleMath"),
        formatSummary: document.getElementById("formatSummary"),
        overridesBadge: document.getElementById("overridesBadge"),
        ovParticipantSingular: document.getElementById("ovParticipantSingular"),
        ovParticipantPlural: document.getElementById("ovParticipantPlural"),
        ovVenueSingular: document.getElementById("ovVenueSingular"),
        ovVenuePlural: document.getElementById("ovVenuePlural"),
        ovScoreLabel: document.getElementById("ovScoreLabel"),
        ovAllowDraws: document.getElementById("ovAllowDraws"),
        resetOverridesBtn: document.getElementById("resetOverridesBtn"),
        namesTitle: document.getElementById("namesTitle"),
        namesPreviewList: document.getElementById("namesPreviewList"),
        remainingNamesPanel: document.getElementById("remainingNamesPanel"),
        remainingNamesSummary: document.getElementById("remainingNamesSummary"),
        namesList: document.getElementById("namesList"),
        generateBtn: document.getElementById("generateBtn"),
        scheduleTab: document.getElementById("scheduleTab"),
        roundsTab: document.getElementById("roundsTab"),
        standingsTab: document.getElementById("standingsTab"),
        qualityTab: document.getElementById("qualityTab"),
        schedulePane: document.getElementById("schedulePane"),
        roundsPane: document.getElementById("roundsPane"),
        standingsPane: document.getElementById("standingsPane"),
        qualityPane: document.getElementById("qualityPane"),
        shareBtn: document.getElementById("shareBtn"),
        saveFileBtn: document.getElementById("saveFileBtn"),
        loadFileBtn: document.getElementById("loadFileBtn"),
        loadFileMenuBtn: document.getElementById("loadFileMenuBtn"),
        loadFileInput: document.getElementById("loadFileInput"),
        moreActions: document.getElementById("moreActions"),
        printBtn: document.getElementById("printBtn"),
        csvBtn: document.getElementById("csvBtn"),
        resetBtn: document.getElementById("resetBtn"),
        actionStatus: document.getElementById("actionStatus"),
        participantMetric: document.getElementById("participantMetric"),
        participantMetricLabel: document.getElementById("participantMetricLabel"),
        roundMetric: document.getElementById("roundMetric"),
        matchMetric: document.getElementById("matchMetric"),
        slotMetric: document.getElementById("slotMetric"),
        scheduleBadge: document.getElementById("scheduleBadge"),
        modeBadge: document.getElementById("modeBadge"),
        scoringBadge: document.getElementById("scoringBadge"),
        operationalOutput: document.getElementById("operationalOutput"),
        scheduleNotice: document.getElementById("scheduleNotice"),
        scheduleOutput: document.getElementById("scheduleOutput"),
        standingsOutput: document.getElementById("standingsOutput"),
        qualityOutput: document.getElementById("qualityOutput")
      };

      var defaultSport = profiles[root.dataset.defaultSport] ? root.dataset.defaultSport : "generic";
      var defaultCount = parseInteger(root.dataset.defaultCount, profiles[defaultSport].defaultCount);
      var defaultStartDate = todayIso();

      var saveStateDebounced = null;
      (function () {
        var timer = null;
        saveStateDebounced = function () {
          if (timer) window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            timer = null;
            saveState();
          }, 400);
        };
        saveStateDebounced.flush = function () {
          if (timer) {
            window.clearTimeout(timer);
            timer = null;
            saveState();
          }
        };
      })();

      var hasSharedUrlState = hasShareStateInUrl();
      var importedProject = loadStateFromUrl();
      var importedState = importedProject ? importedProject.state : null;
      var importedLoadFailed = hasSharedUrlState && !importedProject;
      var sharedImportPendingEdit = false;
      var state = importedState || loadState() || makeDefaultState();

      try {
        normalizeState();
        if (importedProject && importedProject.generated) {
          state.schedule = generateRoundRobin(state.names, state.doubleRoundRobin, state.venues, getProfile());
          state.activeView = "schedule";
        }
      } catch (error) {
        importedLoadFailed = Boolean(importedProject);
        state = loadState() || makeDefaultState();
        try {
          normalizeState();
        } catch (storageError) {
          state = makeDefaultState();
          normalizeState();
        }
      }
      bindEvents();
      try {
        renderAll();
      } catch (error) {
        importedLoadFailed = Boolean(importedProject);
        state = makeDefaultState();
        normalizeState();
        renderAll();
      }
      if (importedProject && !importedLoadFailed) {
        // Render the shared schedule but do NOT overwrite any tournament already
        // saved in this browser; the share payload lives in the URL hash, and
        // autosave will persist once the user actually edits something.
        sharedImportPendingEdit = true;
        els.autosaveStatus.textContent = "Loaded from link";
        setActionStatus("Loaded schedule from share URL.");
      } else if (importedLoadFailed) {
        setActionStatus("Could not load share URL.");
      }

      function bindEvents() {
        els.sportButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            var oldProfile = getProfile();
            state.sport = button.dataset.sport;
            state.overrides = {};
            var nextProfile = getProfile();
            state.venues = nextProfile.defaultVenues;
            state.names = state.names.map(function (name, index) {
              var oldDefault = oldProfile.participantSingular + " " + (index + 1);
              var nextDefault = nextProfile.participantSingular + " " + (index + 1);
              return name === oldDefault ? nextDefault : name;
            });
            els.sportSelector.open = false;
            filterPresetOptions("");
            clearSchedule();
          });
        });

        els.presetSearchInput.addEventListener("input", function () {
          filterPresetOptions(els.presetSearchInput.value);
        });

        els.sportSelector.addEventListener("toggle", function () {
          if (!els.sportSelector.open) filterPresetOptions("");
        });

        els.ovParticipantSingular.addEventListener("input", function () {
          setOverride("participantSingular", els.ovParticipantSingular.value);
        });
        els.ovParticipantPlural.addEventListener("input", function () {
          setOverride("participantPlural", els.ovParticipantPlural.value);
        });
        els.ovVenueSingular.addEventListener("input", function () {
          setOverride("venueSingular", els.ovVenueSingular.value);
        });
        els.ovVenuePlural.addEventListener("input", function () {
          setOverride("venuePlural", els.ovVenuePlural.value);
        });
        els.ovScoreLabel.addEventListener("input", function () {
          var value = els.ovScoreLabel.value.trim();
          if (value) {
            state.overrides.scoreA = value;
            state.overrides.scoreB = value;
          } else {
            delete state.overrides.scoreA;
            delete state.overrides.scoreB;
          }
          renderAll();
          saveState();
        });
        els.ovAllowDraws.addEventListener("change", function () {
          state.overrides.allowDraws = els.ovAllowDraws.checked;
          renderAll();
          saveState();
        });
        els.resetOverridesBtn.addEventListener("click", function () {
          state.overrides = {};
          renderAll();
          saveState();
          setActionStatus("Labels and scoring reset to preset.");
        });

        els.countDownBtn.addEventListener("click", function () {
          setCount(state.count - 1);
        });

        els.countUpBtn.addEventListener("click", function () {
          setCount(state.count + 1);
        });

        els.applyBulkBtn.addEventListener("click", applyBulkNames);

        els.remainingNamesPanel.addEventListener("toggle", function () {
          updateRemainingNamesSummary(getProfile());
        });
        els.remainingNamesSummary.addEventListener("click", function () {
          window.setTimeout(function () {
            updateRemainingNamesSummary(getProfile());
          }, 0);
        });

        els.venueInput.addEventListener("change", function () {
          state.venues = clamp(parseInteger(els.venueInput.value, state.venues), 1, 32);
          clearSchedule();
        });

        els.startDateInput.addEventListener("change", function () {
          state.startDate = validIsoDate(els.startDateInput.value) ? els.startDateInput.value : todayIso();
          if (!state.playDays.length) state.playDays = [weekdayFromIso(state.startDate)];
          renderAll();
          saveState();
        });

        els.dayButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            var day = parseInteger(button.dataset.day, 0);
            if (state.playDays.indexOf(day) === -1) {
              state.playDays.push(day);
            } else if (state.playDays.length > 1) {
              state.playDays = state.playDays.filter(function (value) {
                return value !== day;
              });
            }
            state.playDays.sort(function (a, b) {
              return a - b;
            });
            renderAll();
            saveState();
          });
        });

        els.timeSlotsInput.addEventListener("input", function () {
          state.timeSlotsText = els.timeSlotsInput.value;
          renderAll();
          saveStateDebounced();
        });

        els.venueNamesInput.addEventListener("input", function () {
          state.venueNamesText = els.venueNamesInput.value;
          renderAll();
          saveStateDebounced();
        });

        els.singleBtn.addEventListener("click", function () {
          state.doubleRoundRobin = false;
          clearSchedule();
        });

        els.doubleBtn.addEventListener("click", function () {
          state.doubleRoundRobin = true;
          clearSchedule();
        });

        els.generateBtn.addEventListener("click", regenerateSchedule);
        var tabControls = [
          { tab: els.scheduleTab, view: "schedule" },
          { tab: els.roundsTab, view: "rounds" },
          { tab: els.standingsTab, view: "standings" },
          { tab: els.qualityTab, view: "quality" }
        ];
        tabControls.forEach(function (entry) {
          entry.tab.addEventListener("click", function () {
            setActiveView(entry.view, true);
          });
          entry.tab.addEventListener("keydown", function (event) {
            if (["ArrowRight", "ArrowLeft", "Home", "End"].indexOf(event.key) === -1) return;
            var visible = tabControls.filter(function (item) {
              return item.tab.offsetParent !== null;
            });
            var index = visible.indexOf(entry);
            if (index === -1) return;
            var nextIndex;
            if (event.key === "Home") nextIndex = 0;
            else if (event.key === "End") nextIndex = visible.length - 1;
            else if (event.key === "ArrowRight") nextIndex = (index + 1) % visible.length;
            else nextIndex = (index - 1 + visible.length) % visible.length;
            event.preventDefault();
            setActiveView(visible[nextIndex].view, true);
            visible[nextIndex].tab.focus();
          });
        });
        els.shareBtn.addEventListener("click", shareScheduleUrl);
        els.saveFileBtn.addEventListener("click", saveProjectFile);
        els.loadFileBtn.addEventListener("click", function () {
          els.loadFileInput.click();
        });
        els.loadFileMenuBtn.addEventListener("click", function () {
          els.moreActions.open = false;
          els.loadFileInput.click();
        });
        els.loadFileInput.addEventListener("change", loadProjectFile);
        els.printBtn.addEventListener("click", function () {
          var priorView = state.activeView;
          setActiveView("schedule", false);
          window.print();
          if (priorView !== "schedule") setActiveView(priorView, false);
        });
        els.csvBtn.addEventListener("click", exportCsv);
        els.resetBtn.addEventListener("click", function () {
          els.moreActions.open = false;
          resetState();
        });

        document.addEventListener("click", function (event) {
          [els.moreActions, els.sportSelector].forEach(function (el) {
            if (el && el.open && !el.contains(event.target)) el.open = false;
          });
        });
        document.addEventListener("keydown", function (event) {
          if (event.key !== "Escape") return;
          [els.moreActions, els.sportSelector].forEach(function (el) {
            if (el && el.open) el.open = false;
          });
        });
        window.addEventListener("beforeunload", function () {
          saveStateDebounced.flush();
        });
      }

      function getProfile() {
        var base = profiles[state.sport] || profiles.generic;
        return Object.assign({}, base, sanitizeOverrides(state.overrides));
      }

      function sanitizeOverrides(raw) {
        var labelKeys = ["participantSingular", "participantPlural", "venueSingular", "venuePlural", "scoreA", "scoreB"];
        var clean = {};
        if (!raw || typeof raw !== "object") return clean;
        labelKeys.forEach(function (key) {
          if (typeof raw[key] === "string") {
            var value = raw[key].trim().slice(0, 40);
            if (value) clean[key] = value;
          }
        });
        if (typeof raw.allowDraws === "boolean") clean.allowDraws = raw.allowDraws;
        return clean;
      }

      function setFieldValue(input, value) {
        if (document.activeElement !== input) input.value = value;
      }

      function setOverride(key, value) {
        if (!state.overrides) state.overrides = {};
        var trimmed = (value || "").trim();
        if (trimmed) state.overrides[key] = trimmed;
        else delete state.overrides[key];
        renderAll();
        saveState();
      }

      function filterPresetOptions(query) {
        var needle = (query || "").trim().toLowerCase();
        if (!needle && els.presetSearchInput.value) els.presetSearchInput.value = "";
        els.sportButtons.forEach(function (button) {
          var haystack = (button.dataset.search || button.dataset.label || button.textContent || "").toLowerCase();
          button.hidden = needle ? haystack.indexOf(needle) === -1 : false;
        });
      }

      function normalizeState() {
        if (!profiles[state.sport]) state.sport = defaultSport;
        state.overrides = sanitizeOverrides(state.overrides);
        state.count = clamp(parseInteger(state.count, defaultCount), 2, 64);
        state.venues = clamp(parseInteger(state.venues, getProfile().defaultVenues), 1, 32);
        state.doubleRoundRobin = Boolean(state.doubleRoundRobin);
        state.startDate = validIsoDate(state.startDate) ? state.startDate : defaultStartDate;
        if (!Array.isArray(state.playDays)) state.playDays = [];
        state.playDays = state.playDays.map(function (day) {
          return parseInteger(day, weekdayFromIso(state.startDate));
        }).filter(function (day, index, days) {
          return day >= 0 && day <= 6 && days.indexOf(day) === index;
        }).sort(function (a, b) {
          return a - b;
        });
        if (!state.playDays.length) state.playDays = [weekdayFromIso(state.startDate)];
        state.timeSlotsText = typeof state.timeSlotsText === "string" && parseTimeSlots(state.timeSlotsText).length ? state.timeSlotsText : "6:00 PM, 7:00 PM";
        state.venueNamesText = typeof state.venueNamesText === "string" ? state.venueNamesText : "";
        if (!Array.isArray(state.names)) state.names = [];
        syncNameCount();
        state.schedule = normalizeSchedule(state.schedule);
        if (["schedule", "rounds", "standings", "quality"].indexOf(state.activeView) === -1) state.activeView = "schedule";
      }

      function normalizeSchedule(rawSchedule) {
        if (!Array.isArray(rawSchedule)) return [];
        var participantIds = Object.create(null);
        state.names.forEach(function (name, index) {
          participantIds["p" + index] = true;
        });

        var maxRounds = getScheduleMath(state.doubleRoundRobin).rounds;
        var maxMatchesPerRound = Math.max(1, Math.floor(state.count / 2));
        var rounds = [];

        rawSchedule.slice(0, maxRounds).forEach(function (round, roundIndex) {
          if (!round || typeof round !== "object" || !Array.isArray(round.matches)) return;

          var usedInRound = Object.create(null);
          var matches = [];
          round.matches.slice(0, maxMatchesPerRound).forEach(function (match, matchIndex) {
            var normalized = normalizeMatch(match, roundIndex, matchIndex, participantIds, usedInRound);
            if (normalized) matches.push(normalized);
          });

          if (matches.length) {
            rounds.push({
              number: rounds.length + 1,
              matches: matches
            });
          }
        });

        return rounds;
      }

      function normalizeMatch(match, roundIndex, matchIndex, participantIds, usedInRound) {
        if (!match || typeof match !== "object") return null;
        var a = normalizeMatchParticipant(match.a, participantIds);
        var b = normalizeMatchParticipant(match.b, participantIds);
        if (!a || !b || a.id === b.id || usedInRound[a.id] || usedInRound[b.id]) return null;

        usedInRound[a.id] = true;
        usedInRound[b.id] = true;

        return {
          id: "r" + (roundIndex + 1) + "m" + (matchIndex + 1) + "-" + a.id + "-" + b.id,
          a: a,
          b: b,
          venue: clamp(parseInteger(match.venue, (matchIndex % state.venues) + 1), 1, state.venues),
          slot: clamp(parseInteger(match.slot, Math.floor(matchIndex / state.venues) + 1), 1, 1024),
          scoreA: normalizeScore(match.scoreA),
          scoreB: normalizeScore(match.scoreB)
        };
      }

      function normalizeMatchParticipant(raw, participantIds) {
        if (!raw || typeof raw !== "object" || typeof raw.id !== "string" || !participantIds[raw.id]) return null;
        var index = parseInteger(raw.id.slice(1), -1);
        if (index < 0 || index >= state.names.length) return null;
        return {
          id: raw.id,
          name: state.names[index]
        };
      }

      function normalizeScore(value) {
        if (value === null || value === "" || typeof value === "undefined") return null;
        var parsed = Number(value);
        if (!Number.isFinite(parsed)) return null;
        return clamp(Math.floor(parsed), 0, MAX_SCORE);
      }

      function syncNameCount() {
        var profile = getProfile();
        var next = [];
        for (var i = 0; i < state.count; i += 1) {
          next.push(sanitizeName(state.names[i], profile.participantSingular + " " + (i + 1)));
        }
        state.names = next;
      }

      function makeDefaultNames(count, profile) {
        var names = [];
        for (var i = 0; i < count; i += 1) {
          names.push(profile.participantSingular + " " + (i + 1));
        }
        return names;
      }

      function regenerateSchedule() {
        normalizeState();
        state.schedule = generateRoundRobin(state.names, state.doubleRoundRobin, state.venues, getProfile());
        state.activeView = "schedule";
        renderAll();
        saveState();
        scrollOutputAfterGenerate();
      }

      function clearSchedule() {
        normalizeState();
        state.schedule = [];
        renderAll();
        saveState();
      }

      function setCount(value) {
        state.count = clamp(parseInteger(value, state.count), 2, 64);
        syncNameCount();
        clearSchedule();
      }

      function applyBulkNames() {
        var profile = getProfile();
        var allNames = els.bulkNamesInput.value.split(/\n+/).map(function (name) {
          return sanitizeName(name, "");
        }).filter(Boolean);
        var names = allNames.slice(0, 64);
        if (names.length < 2) {
          setActionStatus("Paste at least 2 names.");
          return;
        }
        state.count = names.length;
        state.names = names;
        els.bulkPanel.open = false;
        clearSchedule();
        var message = "Applied " + names.length + " " + profile.participantPlural.toLowerCase() + ".";
        if (allNames.length > 64) {
          message += " Only the first 64 were used (64 max).";
        }
        setActionStatus(message);
      }

      function renderAll() {
        var profile = getProfile();
        root.classList.toggle("has-schedule", state.schedule.length > 0);
        root.classList.toggle("pre-generate", state.schedule.length === 0);
        els.countBig.textContent = state.count;
        els.countSmall.textContent = profile.participantPlural;
        els.participantCountLabel.setAttribute("aria-label", state.count + " " + profile.participantPlural);
        els.venueInput.value = state.venues;
        els.venueLabel.textContent = profile.venuePlural;
        els.venueNamesLabel.textContent = profile.venueSingular + " names";
        els.advancedHelp.textContent = "Schedule view assigns each match to the next available play day, time, and " + profile.venueSingular.toLowerCase() + ".";
        els.startDateInput.value = state.startDate;
        els.timeSlotsInput.value = state.timeSlotsText;
        els.venueNamesInput.value = state.venueNamesText;
        if (document.activeElement !== els.bulkNamesInput) {
          els.bulkNamesInput.value = state.names.join("\n");
        }
        els.venueNamesInput.placeholder = getVenueNames(profile).join("\n");
        els.namesTitle.textContent = profile.participantPlural;
        setFieldValue(els.ovParticipantSingular, profile.participantSingular);
        setFieldValue(els.ovParticipantPlural, profile.participantPlural);
        setFieldValue(els.ovVenueSingular, profile.venueSingular);
        setFieldValue(els.ovVenuePlural, profile.venuePlural);
        setFieldValue(els.ovScoreLabel, profile.scoreA);
        els.ovAllowDraws.checked = profile.allowDraws;
        var hasOverrides = Object.keys(sanitizeOverrides(state.overrides)).length > 0;
        els.overridesBadge.hidden = !hasOverrides;
        els.resetOverridesBtn.disabled = !hasOverrides;
        els.singleBtn.setAttribute("aria-pressed", String(!state.doubleRoundRobin));
        els.doubleBtn.setAttribute("aria-pressed", String(state.doubleRoundRobin));
        els.sportButtons.forEach(function (button) {
          button.setAttribute("aria-pressed", String(button.dataset.sport === state.sport));
          if (button.dataset.sport === state.sport) {
            els.selectedSportLabel.textContent = button.dataset.label || button.textContent.trim();
          }
        });
        els.dayButtons.forEach(function (button) {
          var day = parseInteger(button.dataset.day, 0);
          button.setAttribute("aria-pressed", String(state.playDays.indexOf(day) !== -1));
        });
        els.participantMetric.textContent = state.count;
        els.participantMetricLabel.textContent = profile.participantPlural;
        els.scheduleBadge.textContent = parseTimeSlots(state.timeSlotsText).length + " time slots";
        els.modeBadge.textContent = state.doubleRoundRobin ? "Double round robin" : "Single round robin";
        els.scoringBadge.textContent = profile.scoringBadge;
        renderNames(profile);
        renderSummary();
        renderFormatSummary(profile);
        renderNotice();
        renderOperationalSchedule(profile);
        renderSchedule(profile);
        renderStandings(profile);
        renderQuality(profile);
        setActiveView(state.activeView, false);
      }

      function renderNames(profile) {
        var remainingCount = Math.max(0, state.names.length - NAME_PREVIEW_LIMIT);
        els.namesPreviewList.innerHTML = "";
        els.namesList.innerHTML = "";
        els.remainingNamesPanel.hidden = remainingCount === 0;
        if (remainingCount === 0) {
          els.remainingNamesPanel.open = false;
        }
        updateRemainingNamesSummary(profile);

        state.names.forEach(function (name, index) {
          var row = makeNameRow(profile, name, index);
          if (index < NAME_PREVIEW_LIMIT) {
            els.namesPreviewList.appendChild(row);
          } else {
            els.namesList.appendChild(row);
          }
        });
      }

      function updateRemainingNamesSummary(profile) {
        var remainingCount = Math.max(0, state.names.length - NAME_PREVIEW_LIMIT);
        var remainingLabel = remainingCount === 1 ? profile.participantSingular.toLowerCase() : profile.participantPlural.toLowerCase();
        els.remainingNamesSummary.textContent = els.remainingNamesPanel.open ? "Hide extra " + remainingLabel : "Show " + remainingCount + " more " + remainingLabel;
      }

      function makeNameRow(profile, name, index) {
        var row = document.createElement("div");
        row.className = "name-row";

        var number = document.createElement("span");
        number.className = "name-index";
        number.textContent = String(index + 1);

        var input = document.createElement("input");
        input.type = "text";
        input.maxLength = MAX_NAME_LENGTH;
        input.value = name;
        input.setAttribute("aria-label", profile.participantSingular + " " + (index + 1));
        input.addEventListener("input", function () {
          state.names[index] = sanitizeName(input.value, profile.participantSingular + " " + (index + 1));
          updateScheduleNames();
          renderOperationalSchedule(profile);
          renderSchedule(profile);
          renderStandings(profile);
          saveStateDebounced();
        });

        row.appendChild(number);
        row.appendChild(input);
        return row;
      }

      function renderSummary() {
        var math = getScheduleMath(state.doubleRoundRobin);
        var rounds = state.schedule.length || math.rounds;
        var matches = state.schedule.length ? state.schedule.reduce(function (sum, round) {
          return sum + round.matches.length;
        }, 0) : math.matches;
        var slots = state.schedule.length ? state.schedule.reduce(function (sum, round) {
          var maxSlot = round.matches.reduce(function (roundMax, match) {
            return Math.max(roundMax, match.slot);
          }, 0);
          return sum + maxSlot;
        }, 0) : math.slots;

        els.roundMetric.textContent = String(rounds);
        els.matchMetric.textContent = String(matches);
        els.slotMetric.textContent = String(slots);
      }

      function renderFormatSummary(profile) {
        var single = getScheduleMath(false);
        var double = getScheduleMath(true);
        var current = state.doubleRoundRobin ? double : single;
        var cycleText = state.doubleRoundRobin ? "Every " + profile.participantSingular.toLowerCase() + " matchup repeats with sides reversed." : "Every " + profile.participantSingular.toLowerCase() + " matchup appears once.";

        els.singleMath.textContent = single.matches + " matches";
        els.doubleMath.textContent = double.matches + " matches";
        els.formatSummary.innerHTML = escapeHtml(cycleText) + "<span>" + current.matches + " matches - " + current.rounds + " rounds - " + current.slots + " time slots</span>";
      }

      function getScheduleMath(doubleRoundRobin) {
        var count = state.count;
        var adjustedCount = count % 2 === 0 ? count : count + 1;
        var cycles = doubleRoundRobin ? 2 : 1;
        var rounds = (adjustedCount - 1) * cycles;
        var matches = (count * (count - 1) / 2) * cycles;
        var matchesPerRound = Math.floor(adjustedCount / 2);
        if (count % 2 === 1) matchesPerRound -= 1;
        var slotsPerRound = Math.max(1, Math.ceil(matchesPerRound / Math.max(1, state.venues)));
        return {
          rounds: rounds,
          matches: matches,
          slots: rounds * slotsPerRound
        };
      }

      function renderNotice() {
        var profile = getProfile();
        els.scheduleNotice.innerHTML = "";
        if (state.count % 2 === 1) {
          var notice = document.createElement("div");
          notice.className = "notice";
          notice.textContent = "Odd " + profile.participantPlural.toLowerCase() + " create one bye per round.";
          els.scheduleNotice.appendChild(notice);
        }
      }

      function renderOperationalSchedule(profile) {
        els.operationalOutput.innerHTML = "";
        if (!state.schedule.length) {
          var empty = document.createElement("div");
          empty.className = "empty-state";
          var card = document.createElement("div");
          card.className = "ready-card";
          card.innerHTML = [
            "<span class=\"ready-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" aria-hidden=\"true\"><path d=\"M13 2L4 14h7l-1 8 10-13h-7z\"></path></svg></span>",
            "<h3>Ready to schedule</h3>",
            "<p>Generate match pairings, then this view assigns dates, times, and " + escapeHtml(profile.venuePlural.toLowerCase()) + ".</p>"
          ].join("");
          empty.appendChild(card);
          els.operationalOutput.appendChild(empty);
          return;
        }

        var rows = buildOperationalRows(profile);
        var rounds = [];
        rows.forEach(function (row) {
          var round = rounds.filter(function (item) {
            return item.number === row.round;
          })[0];
          if (!round) {
            round = { number: row.round, days: [] };
            rounds.push(round);
          }
          var day = round.days.filter(function (item) {
            return item.iso === row.dateIso;
          })[0];
          if (!day) {
            day = { iso: row.dateIso, label: row.dateLabel, matches: [] };
            round.days.push(day);
          }
          day.matches.push(row);
        });

        rounds.forEach(function (round) {
          var roundEl = document.createElement("section");
          roundEl.className = "event-round";

          var title = document.createElement("h3");
          title.className = "event-round-title";
          title.textContent = "Round " + round.number;
          roundEl.appendChild(title);

          round.days.forEach(function (day) {
            var dayEl = document.createElement("div");
            dayEl.className = "event-day";

            var dateEl = document.createElement("div");
            dateEl.className = "event-date";
            dateEl.textContent = day.label;
            dayEl.appendChild(dateEl);

            day.matches.forEach(function (match) {
              var rowEl = document.createElement("div");
              rowEl.className = "event-match";

              var venue = document.createElement("div");
              venue.className = "event-venue";
              venue.textContent = match.venue;

              var time = document.createElement("div");
              time.className = "event-time";
              time.textContent = match.time;

              var left = document.createElement("div");
              left.className = "team-name event-team-left";
              left.textContent = match.a;

              var versus = document.createElement("span");
              versus.className = "versus";
              versus.textContent = "vs";

              var right = document.createElement("div");
              right.className = "team-name event-team-right";
              right.textContent = match.b;

              rowEl.appendChild(venue);
              rowEl.appendChild(time);
              rowEl.appendChild(left);
              rowEl.appendChild(versus);
              rowEl.appendChild(right);
              dayEl.appendChild(rowEl);
            });

            roundEl.appendChild(dayEl);
          });

          els.operationalOutput.appendChild(roundEl);
        });
      }

      function renderSchedule(profile) {
        els.scheduleOutput.innerHTML = "";
        if (!state.schedule.length) {
          var empty = document.createElement("div");
          empty.className = "empty-state";
          var card = document.createElement("div");
          card.className = "ready-card";
          card.innerHTML = [
            "<span class=\"ready-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" aria-hidden=\"true\"><path d=\"M13 2L4 14h7l-1 8 10-13h-7z\"></path></svg></span>",
            "<h3>Ready to generate</h3>",
            "<p>Set your " + escapeHtml(profile.participantPlural.toLowerCase()) + ", format, and preset, then generate the schedule.</p>"
          ].join("");
          empty.appendChild(card);
          els.scheduleOutput.appendChild(empty);
          return;
        }

        state.schedule.forEach(function (round, roundIndex) {
          var details = document.createElement("details");
          details.className = "round";
          if (roundIndex < 3) details.open = true;

          var summary = document.createElement("summary");
          var title = document.createElement("span");
          title.className = "round-title";
          title.textContent = "Round " + round.number;
          var count = document.createElement("span");
          count.className = "round-count";
          count.textContent = round.matches.length + " matches";
          summary.appendChild(title);
          summary.appendChild(count);

          var matches = document.createElement("div");
          matches.className = "matches";

          round.matches.forEach(function (match) {
            matches.appendChild(renderMatch(match, profile));
          });

          details.appendChild(summary);
          details.appendChild(matches);
          els.scheduleOutput.appendChild(details);
        });
      }

      function renderMatch(match, profile) {
        var row = document.createElement("div");
        row.className = "match-row";

        var venue = document.createElement("span");
        venue.className = "venue";
        venue.textContent = profile.venueSingular + " " + match.venue + " / Slot " + match.slot;

        var a = document.createElement("div");
        a.className = "team-name";
        a.textContent = match.a.name;

        var scoreA = document.createElement("input");
        scoreA.className = "score-input";
        scoreA.type = "number";
        scoreA.min = "0";
        scoreA.max = String(MAX_SCORE);
        scoreA.step = "1";
        scoreA.inputMode = "numeric";
        scoreA.placeholder = profile.scoreA;
        scoreA.value = match.scoreA === null ? "" : String(match.scoreA);
        scoreA.setAttribute("aria-label", match.a.name + " score");
        scoreA.addEventListener("input", function () {
          match.scoreA = normalizeScore(scoreA.value);
          renderOperationalSchedule(profile);
          renderStandings(profile);
          saveStateDebounced();
        });

        var versus = document.createElement("span");
        versus.className = "versus";
        versus.textContent = "vs";

        var scoreB = document.createElement("input");
        scoreB.className = "score-input";
        scoreB.type = "number";
        scoreB.min = "0";
        scoreB.max = String(MAX_SCORE);
        scoreB.step = "1";
        scoreB.inputMode = "numeric";
        scoreB.placeholder = profile.scoreB;
        scoreB.value = match.scoreB === null ? "" : String(match.scoreB);
        scoreB.setAttribute("aria-label", match.b.name + " score");
        scoreB.addEventListener("input", function () {
          match.scoreB = normalizeScore(scoreB.value);
          renderOperationalSchedule(profile);
          renderStandings(profile);
          saveStateDebounced();
        });

        var b = document.createElement("div");
        b.className = "team-name";
        b.textContent = match.b.name;

        row.appendChild(venue);
        row.appendChild(a);
        row.appendChild(scoreA);
        row.appendChild(versus);
        row.appendChild(scoreB);
        row.appendChild(b);
        return row;
      }

      function renderStandings(profile) {
        els.standingsOutput.innerHTML = "";
        if (!state.schedule.length) {
          var empty = document.createElement("div");
          empty.className = "empty-state";
          empty.innerHTML = "<div class=\"ready-card\"><h3>No standings yet</h3><p>Generate a schedule, then enter scores to rank " + escapeHtml(profile.participantPlural.toLowerCase()) + ".</p></div>";
          els.standingsOutput.appendChild(empty);
          return;
        }

        var standings = calculateStandings(state.names, state.schedule, profile);
        var wrap = document.createElement("div");
        wrap.className = "table-wrap";

        var table = document.createElement("table");
        var showDraws = profile.allowDraws;
        var thead = document.createElement("thead");
        var headCells = ["<th>" + escapeHtml(profile.participantSingular) + "</th>", "<th>Pl</th>", "<th>W</th>", "<th>L</th>"];
        if (showDraws) headCells.push("<th>D</th>");
        headCells.push("<th>For</th>", "<th>Against</th>", "<th>Diff</th>", "<th>Pts</th>");
        thead.innerHTML = "<tr>" + headCells.join("") + "</tr>";
        table.appendChild(thead);

        var tbody = document.createElement("tbody");
        standings.forEach(function (row) {
          var tr = document.createElement("tr");
          var cells = [
            "<td>" + escapeHtml(row.name) + "</td>",
            "<td>" + row.played + "</td>",
            "<td>" + row.wins + "</td>",
            "<td>" + row.losses + "</td>"
          ];
          if (showDraws) cells.push("<td>" + row.draws + "</td>");
          cells.push(
            "<td>" + row.for + "</td>",
            "<td>" + row.against + "</td>",
            "<td>" + signed(row.diff) + "</td>",
            "<td>" + row.points + "</td>"
          );
          tr.innerHTML = cells.join("");
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        wrap.appendChild(table);

        els.standingsOutput.appendChild(wrap);
      }

      function renderQuality(profile) {
        els.qualityOutput.innerHTML = "";
        if (!state.schedule.length) {
          var empty = document.createElement("div");
          empty.className = "empty-state";
          empty.innerHTML = "<div class=\"ready-card\"><h3>No audit yet</h3><p>Generate a schedule to check byes, games, home/away balance, and venue spread.</p></div>";
          els.qualityOutput.appendChild(empty);
          return;
        }

        var audit = calculateQualityAudit(profile);
        var grid = document.createElement("div");
        grid.className = "audit-grid";
        [
          ["Games spread", audit.gamesSpread],
          ["Bye spread", audit.byeSpread],
          ["Home spread", audit.homeSpread],
          ["Venue spread", audit.venueSpread]
        ].forEach(function (item) {
          var card = document.createElement("div");
          card.className = "audit-card";
          card.innerHTML = "<span class=\"audit-value\">" + escapeHtml(item[1]) + "</span><span class=\"audit-label\">" + escapeHtml(item[0]) + "</span>";
          grid.appendChild(card);
        });
        els.qualityOutput.appendChild(grid);

        var wrap = document.createElement("div");
        wrap.className = "table-wrap";
        var table = document.createElement("table");
        table.innerHTML = "<thead><tr><th>" + escapeHtml(profile.participantSingular) + "</th><th>Games</th><th>Byes</th><th>Home</th><th>Away</th><th>Venues</th></tr></thead>";
        var tbody = document.createElement("tbody");
        audit.rows.forEach(function (row) {
          var tr = document.createElement("tr");
          tr.innerHTML = [
            "<td>" + escapeHtml(row.name) + "</td>",
            "<td>" + row.games + "</td>",
            "<td>" + row.byes + "</td>",
            "<td>" + row.home + "</td>",
            "<td>" + row.away + "</td>",
            "<td>" + row.venues + "</td>"
          ].join("");
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        wrap.appendChild(table);
        els.qualityOutput.appendChild(wrap);

        var notes = document.createElement("div");
        notes.className = "audit-note";
        notes.innerHTML = audit.notes.map(function (note) {
          return "<div>" + escapeHtml(note) + "</div>";
        }).join("");
        els.qualityOutput.appendChild(notes);
      }

      function calculateQualityAudit(profile) {
        var rows = Object.create(null);
        state.names.forEach(function (name, index) {
          rows["p" + index] = {
            id: "p" + index,
            name: name,
            games: 0,
            byes: 0,
            home: 0,
            away: 0,
            venueSet: Object.create(null)
          };
        });

        state.schedule.forEach(function (round) {
          var played = Object.create(null);
          round.matches.forEach(function (match) {
            if (rows[match.a.id]) {
              rows[match.a.id].games += 1;
              rows[match.a.id].home += 1;
              rows[match.a.id].venueSet[match.venue] = true;
              played[match.a.id] = true;
            }
            if (rows[match.b.id]) {
              rows[match.b.id].games += 1;
              rows[match.b.id].away += 1;
              rows[match.b.id].venueSet[match.venue] = true;
              played[match.b.id] = true;
            }
          });
          Object.keys(rows).forEach(function (id) {
            if (!played[id]) rows[id].byes += 1;
          });
        });

        var auditRows = Object.keys(rows).map(function (id) {
          var row = rows[id];
          row.venues = Object.keys(row.venueSet).length;
          return row;
        });
        var games = auditRows.map(function (row) { return row.games; });
        var byes = auditRows.map(function (row) { return row.byes; });
        var homes = auditRows.map(function (row) { return row.home; });
        var venues = auditRows.map(function (row) { return row.venues; });
        var notes = [
          "This audit checks standard round robin balance.",
          profile.participantPlural + " should usually have equal games in a complete round robin; odd counts naturally create byes."
        ];

        return {
          gamesSpread: spreadLabel(games),
          byeSpread: spreadLabel(byes),
          homeSpread: spreadLabel(homes),
          venueSpread: spreadLabel(venues),
          rows: auditRows,
          notes: notes
        };
      }

      function buildOperationalRows(profile) {
        var rows = [];
        var timeSlots = parseTimeSlots(state.timeSlotsText);
        var venueNames = getVenueNames(profile);
        var getPlayDate = makePlayDateGetter();
        var roundStartDateIndex = 0;

        state.schedule.forEach(function (round) {
          var roundDateSpan = 1;
          round.matches.forEach(function (match) {
            var slotIndex = Math.max(0, match.slot - 1);
            var dateOffset = Math.floor(slotIndex / timeSlots.length);
            var dateIso = getPlayDate(roundStartDateIndex + dateOffset);
            roundDateSpan = Math.max(roundDateSpan, dateOffset + 1);
            rows.push({
              round: round.number,
              dateIso: dateIso,
              dateLabel: formatDateLabel(dateIso),
              time: timeSlots[slotIndex % timeSlots.length],
              venue: venueNames[match.venue - 1] || profile.venueSingular + " " + match.venue,
              a: match.a.name,
              b: match.b.name,
              scoreA: match.scoreA,
              scoreB: match.scoreB
            });
          });
          roundStartDateIndex += roundDateSpan;
        });

        return rows;
      }

      function parseTimeSlots(text) {
        var source = typeof text === "string" ? text : "";
        var slots = source.split(/[\n,;]+/).map(function (slot) {
          return slot.trim();
        }).filter(Boolean);
        return slots.length ? slots : ["6:00 PM"];
      }

      function getVenueNames(profile) {
        var custom = state.venueNamesText.split(/[\n,;]+/).map(function (name) {
          return name.trim();
        }).filter(Boolean);
        var names = [];
        for (var i = 0; i < state.venues; i += 1) {
          names.push(custom[i] || profile.venueSingular + " " + (i + 1));
        }
        return names;
      }

      function makePlayDateGetter() {
        var selectedDays = state.playDays.slice();
        var date = parseIsoDate(state.startDate);
        var dates = [];
        return function (index) {
          while (dates.length <= index) {
            if (selectedDays.indexOf(date.getDay()) !== -1) {
              dates.push(toIsoDate(date));
            }
            date.setDate(date.getDate() + 1);
          }
          return dates[index];
        };
      }

      function formatDateLabel(iso) {
        var date = parseIsoDate(iso);
        return date.toLocaleDateString(undefined, {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        });
      }

      function setActiveView(view, persist) {
        if (!state.schedule.length && view !== "schedule") view = "schedule";
        var nextView = ["schedule", "rounds", "standings", "quality"].indexOf(view) === -1 ? "schedule" : view;
        state.activeView = nextView;
        els.scheduleTab.setAttribute("aria-selected", String(nextView === "schedule"));
        els.roundsTab.setAttribute("aria-selected", String(nextView === "rounds"));
        els.standingsTab.setAttribute("aria-selected", String(nextView === "standings"));
        els.qualityTab.setAttribute("aria-selected", String(nextView === "quality"));
        els.scheduleTab.tabIndex = nextView === "schedule" ? 0 : -1;
        els.roundsTab.tabIndex = nextView === "rounds" ? 0 : -1;
        els.standingsTab.tabIndex = nextView === "standings" ? 0 : -1;
        els.qualityTab.tabIndex = nextView === "quality" ? 0 : -1;
        els.schedulePane.hidden = nextView !== "schedule";
        els.roundsPane.hidden = nextView !== "rounds";
        els.standingsPane.hidden = nextView !== "standings";
        els.qualityPane.hidden = nextView !== "quality";
        if (persist) saveState({ viewOnly: true });
      }

      function scrollOutputAfterGenerate() {
        if (window.innerWidth > 760) return;
        window.requestAnimationFrame(function () {
          var target = document.querySelector(".output-panel");
          if (target && typeof target.scrollIntoView === "function") {
            target.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        });
      }

      function generateRoundRobin(names, doubleRoundRobin, venues, profile) {
        var participants = names.map(function (name, index) {
          return { id: "p" + index, name: name || profile.participantSingular + " " + (index + 1), bye: false };
        });

        if (participants.length % 2 === 1) {
          participants.push({ id: "bye", name: "BYE", bye: true });
        }

        var rotation = participants.slice();
        var roundCount = rotation.length - 1;
        var rounds = [];

        for (var roundIndex = 0; roundIndex < roundCount; roundIndex += 1) {
          var matches = makeRoundMatches(rotation, roundIndex, venues);
          rounds.push({ number: rounds.length + 1, matches: matches });
          rotation = rotateParticipants(rotation);
        }

        if (doubleRoundRobin) {
          var firstHalf = rounds.slice();
          firstHalf.forEach(function (round) {
            var reversed = round.matches.map(function (match, index) {
              return makeMatch(match.b, match.a, rounds.length + 1, index, venues);
            });
            rounds.push({ number: rounds.length + 1, matches: reversed });
          });
        }

        return rounds;
      }

      function makeRoundMatches(rotation, roundIndex, venues) {
        var matches = [];
        var count = rotation.length;
        for (var i = 0; i < count / 2; i += 1) {
          var left = rotation[i];
          var right = rotation[count - 1 - i];
          if (left.bye || right.bye) continue;

          var flip = i === 0 ? roundIndex % 2 === 1 : i % 2 === 1;
          matches.push(makeMatch(flip ? right : left, flip ? left : right, roundIndex + 1, matches.length, venues));
        }
        return matches;
      }

      function makeMatch(a, b, roundNumber, matchIndex, venues) {
        return {
          id: "r" + roundNumber + "m" + (matchIndex + 1) + "-" + a.id + "-" + b.id,
          a: { id: a.id, name: a.name },
          b: { id: b.id, name: b.name },
          venue: (matchIndex % venues) + 1,
          slot: Math.floor(matchIndex / venues) + 1,
          scoreA: null,
          scoreB: null
        };
      }

      function rotateParticipants(items) {
        return [items[0], items[items.length - 1]].concat(items.slice(1, items.length - 1));
      }

      function calculateStandings(names, schedule, profile) {
        var rows = Object.create(null);
        names.forEach(function (name, index) {
          rows["p" + index] = {
            id: "p" + index,
            name: name,
            played: 0,
            wins: 0,
            losses: 0,
            draws: 0,
            for: 0,
            against: 0,
            diff: 0,
            points: 0
          };
        });

        schedule.forEach(function (round) {
          round.matches.forEach(function (match) {
            if (match.scoreA === null || match.scoreB === null) return;
            // A tie is not a valid result for no-draw sports; leave the match
            // uncounted so W + L + D always reconciles with games played.
            if (match.scoreA === match.scoreB && !profile.allowDraws) return;
            var a = rows[match.a.id];
            var b = rows[match.b.id];
            if (!a || !b) return;

            a.played += 1;
            b.played += 1;
            a.for += match.scoreA;
            a.against += match.scoreB;
            b.for += match.scoreB;
            b.against += match.scoreA;

            if (match.scoreA > match.scoreB) {
              a.wins += 1;
              b.losses += 1;
              a.points += 3;
            } else if (match.scoreB > match.scoreA) {
              b.wins += 1;
              a.losses += 1;
              b.points += 3;
            } else if (profile.allowDraws) {
              a.draws += 1;
              b.draws += 1;
              a.points += 1;
              b.points += 1;
            }
          });
        });

        return Object.keys(rows).map(function (id) {
          var row = rows[id];
          row.diff = row.for - row.against;
          return row;
        }).sort(function (a, b) {
          return b.points - a.points || b.diff - a.diff || b.for - a.for || a.name.localeCompare(b.name);
        });
      }

      function updateScheduleNames() {
        var idToName = Object.create(null);
        state.names.forEach(function (name, index) {
          idToName["p" + index] = name;
        });
        state.schedule.forEach(function (round) {
          round.matches.forEach(function (match) {
            if (idToName[match.a.id]) match.a.name = idToName[match.a.id];
            if (idToName[match.b.id]) match.b.name = idToName[match.b.id];
          });
        });
      }

      function exportCsv() {
        var profile = getProfile();
        var rows = buildOperationalRows(profile);
        var lines = [["Round", "Date", "Time", profile.venueSingular, "Participant A", "Score A", "Score B", "Participant B"]];
        rows.forEach(function (row) {
          lines.push([
            row.round,
            row.dateIso,
            row.time,
            row.venue,
            row.a,
            row.scoreA !== null ? row.scoreA : "",
            row.scoreB !== null ? row.scoreB : "",
            row.b
          ]);
        });

        var csv = lines.map(function (row) {
          return row.map(csvCell).join(",");
        }).join("\n");
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "round-robin-schedule.csv";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      }

      function shareScheduleUrl() {
        var encoded = encodeSharedState(makeSharedState(state));
        var url = window.location.href.split("#")[0] + "#rr=" + encoded;
        if (url.length > MAX_SHARE_URL_LENGTH) {
          setActionStatus("Share URL is too large. Use Save file instead.");
          return;
        }
        copyText(url);
        setActionStatus("Share URL copied.");
      }

      function saveProjectFile() {
        var payload = {
          version: 1,
          savedAt: new Date().toISOString(),
          state: state
        };
        var blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "round-robin-schedule.json";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        setActionStatus("Project file saved.");
      }

      function loadProjectFile() {
        var file = els.loadFileInput.files && els.loadFileInput.files[0];
        if (!file) return;
        if (hasUnsavedWork() && !window.confirm("Load this backup? It replaces your current teams, scores, and dates.")) {
          els.loadFileInput.value = "";
          return;
        }
        var reader = new FileReader();
        reader.onload = function () {
          try {
            var parsed = JSON.parse(String(reader.result || ""));
            var nextState = parsed.state || parsed;
            state = nextState;
            normalizeState();
            renderAll();
            saveState();
            setActionStatus("Project file loaded.");
          } catch (error) {
            setActionStatus("Could not load that file.");
          }
          els.loadFileInput.value = "";
        };
        reader.readAsText(file);
      }

      function hasUnsavedWork() {
        if (state.schedule && state.schedule.length) return true;
        var baseline = makeDefaultState();
        return state.sport !== baseline.sport ||
          state.count !== baseline.count ||
          state.venues !== baseline.venues ||
          state.doubleRoundRobin !== baseline.doubleRoundRobin ||
          state.startDate !== baseline.startDate ||
          state.timeSlotsText !== baseline.timeSlotsText ||
          state.venueNamesText !== baseline.venueNamesText ||
          !sameArray(state.playDays, baseline.playDays) ||
          Object.keys(sanitizeOverrides(state.overrides)).length > 0 ||
          !sameArray(state.names, baseline.names);
      }

      function resetState() {
        if (hasUnsavedWork() && !window.confirm("Start a new schedule? This clears the current teams, scores, and dates.")) {
          return;
        }
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
          // Storage may be unavailable in private browsing modes.
        }
        state = makeDefaultState();
        renderAll();
        saveState();
      }

      function setActionStatus(message) {
        els.actionStatus.textContent = message;
      }

      function copyText(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).catch(function () {
            fallbackCopyText(text);
          });
          return;
        }
        fallbackCopyText(text);
      }

      function fallbackCopyText(text) {
        var input = document.createElement("textarea");
        input.value = text;
        input.setAttribute("readonly", "readonly");
        input.style.position = "fixed";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
        } catch (error) {
          setActionStatus("Copy failed. Use Save file instead.");
        }
        input.remove();
      }

      function saveState(options) {
        if (sharedImportPendingEdit && options && options.viewOnly) return;
        sharedImportPendingEdit = false;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
          els.autosaveStatus.textContent = "Saved locally";
        } catch (error) {
          els.autosaveStatus.textContent = "Local save unavailable";
        }
      }

      function loadState() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      }

      function loadStateFromUrl() {
        var match = window.location.hash.match(/(?:^#|&)rr=([^&]+)/);
        if (!match) return null;
        if (match[1].length > MAX_SHARE_PAYLOAD_LENGTH) return null;
        try {
          return unpackSharedState(decodeSharedState(match[1]));
        } catch (error) {
          return null;
        }
      }

      function hasShareStateInUrl() {
        return /(?:^#|&)rr=([^&]+)/.test(window.location.hash);
      }

      function makeDefaultState() {
        return {
          sport: defaultSport,
          overrides: {},
          count: defaultCount,
          venues: profiles[defaultSport].defaultVenues,
          doubleRoundRobin: false,
          startDate: defaultStartDate,
          playDays: [weekdayFromIso(defaultStartDate)],
          timeSlotsText: "6:00 PM, 7:00 PM",
          venueNamesText: "",
          names: makeDefaultNames(defaultCount, profiles[defaultSport]),
          schedule: [],
          activeView: "schedule"
        };
      }

      function makeSharedState(source) {
        return {
          version: 2,
          sport: source.sport,
          overrides: sanitizeOverrides(source.overrides),
          count: source.count,
          venues: source.venues,
          doubleRoundRobin: source.doubleRoundRobin,
          startDate: source.startDate,
          playDays: Array.isArray(source.playDays) ? source.playDays.slice(0, 7) : [],
          timeSlotsText: source.timeSlotsText,
          venueNamesText: source.venueNamesText,
          names: Array.isArray(source.names) ? source.names.slice(0, 64) : [],
          scheduleGenerated: Array.isArray(source.schedule) && source.schedule.length > 0
        };
      }

      function unpackSharedState(decoded) {
        var source = decoded && decoded.state && typeof decoded.state === "object" ? decoded.state : decoded;
        if (!source || typeof source !== "object") return null;
        var sharedState = {
          sport: source.sport,
          overrides: source.overrides,
          count: source.count,
          venues: source.venues,
          doubleRoundRobin: source.doubleRoundRobin,
          startDate: source.startDate,
          playDays: Array.isArray(source.playDays) ? source.playDays.slice(0, 7) : [],
          timeSlotsText: typeof source.timeSlotsText === "string" ? source.timeSlotsText : "",
          venueNamesText: typeof source.venueNamesText === "string" ? source.venueNamesText : "",
          names: Array.isArray(source.names) ? source.names.slice(0, 64).map(function (name) {
            return sanitizeName(name, "");
          }) : [],
          schedule: [],
          activeView: "schedule"
        };
        return {
          state: sharedState,
          generated: Boolean(source.scheduleGenerated || (Array.isArray(source.schedule) && source.schedule.length))
        };
      }

      function encodeSharedState(value) {
        var json = JSON.stringify(value);
        var encoded = btoa(unescape(encodeURIComponent(json)));
        return encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
      }

      function decodeSharedState(value) {
        var base64 = String(value).replace(/-/g, "+").replace(/_/g, "/");
        while (base64.length % 4) base64 += "=";
        var json = decodeURIComponent(escape(atob(base64)));
        return JSON.parse(json);
      }

      function todayIso() {
        return toIsoDate(new Date());
      }

      function validIsoDate(value) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return false;
        return toIsoDate(parseIsoDate(value)) === value;
      }

      function parseIsoDate(value) {
        var parts = String(value).split("-").map(function (part) {
          return parseInteger(part, 0);
        });
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }

      function weekdayFromIso(value) {
        return parseIsoDate(value).getDay();
      }

      function toIsoDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var day = String(date.getDate()).padStart(2, "0");
        return year + "-" + month + "-" + day;
      }

      function parseInteger(value, fallback) {
        var parsed = parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      function sanitizeName(value, fallback) {
        var source = typeof value === "string" ? value : String(value || "");
        var text = source.trim().replace(/\s+/g, " ").slice(0, MAX_NAME_LENGTH);
        return text || fallback;
      }

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function signed(value) {
        return value > 0 ? "+" + value : String(value);
      }

      function spreadLabel(values) {
        if (!values.length) return "0";
        var min = Math.min.apply(Math, values);
        var max = Math.max.apply(Math, values);
        return min === max ? String(min) : min + "-" + max;
      }

      function sameArray(a, b) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
        for (var i = 0; i < a.length; i += 1) {
          if (a[i] !== b[i]) return false;
        }
        return true;
      }

      function escapeHtml(value) {
        return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      }

      function csvCell(value) {
        var text = String(value);
        if (/^[=+\-@\t\r\n]/.test(text)) {
          text = "'" + text;
        }
        if (/[",\r\n]/.test(text)) {
          return "\"" + text.replace(/"/g, "\"\"") + "\"";
        }
        return text;
      }
    })();
